import fetcher from 'api/fetcher';
import { getAlreadyShownRequisitesWarnings } from 'utils/requisites';

import { RequisitesWarning, setRequisitesWarning } from 'store/models/requisites';
import { AppThunkAction } from 'store/utils';

interface Result {
    payerInfo: RequisitesWarning;
}

export const checkRequisites = (show: () => void): AppThunkAction => {
    return (dispatch) => {
        return fetcher.get<unknown, Result>('/api/v1/requisites/check').then(({ payerInfo }) => {
            const alreadyShownWarnings = getAlreadyShownRequisitesWarnings();
            if (payerInfo && !alreadyShownWarnings.includes(payerInfo.payerId.toString())) {
                show();
                dispatch(setRequisitesWarning(payerInfo));
            }
        });
    };
};
